export default function adminReducer(state = [], action) {
    switch (action.type){
        
        case "SET_ADMIN":
            return action.admin;
        case "SET_SELECTION":
            return {...state, selection: action.selection};
        case "SET_SESSIONS":
            return {...state, sessions: action.sessions};
        default:
            return state;
    }
}